import "./Crud.css";
import React from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteOutline, MdUnarchive } from "react-icons/md";
import { IoMdArchive } from "react-icons/io";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { useState ,useEffect} from "react";
import { useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import {
  updateOnFalse,
  updateOnTrue,
  deleteElement,
  onDeleteUser,
  getDocument,
  updateElement,
} from "../../Firebase";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";

function Crud({ isArchived, elt_collection, id }) {
  const [userDatas, setUserDatas] = useState({});
  const [show, setShow] = useState(false);
  const myArchice = "isArchived";
  const trueArchive = "Archiver avec succès";
  const falseArchive = "Désarchiver avec succès";
  const {
    register,
    handleSubmit,
    onSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onUpdate = (data) => {
    updateElement("users", id, data);
    reset();
    handleClose();
  };

  useEffect(() => {
    getDocument("users", id, setUserDatas);
  }, [id]);

  return (
    <>
    <Dropdown className="dropdow132" as={ButtonGroup}>
      <Dropdown.Toggle id="dropdown-custom-1">
        <BiDotsVerticalRounded className="icon132 " />
      </Dropdown.Toggle>
      <Dropdown.Menu className="super-colors dropdow133">
        <h6 className="text-center">Setting</h6>
        <Dropdown.Item eventKey="1">
          {/* <button  onClick={handleShow} >Edit</button>  */}
          <Button variant="primary" className="text-dark" onClick={handleShow}>
            <FaRegEdit /> Edit
          </Button>
        </Dropdown.Item>
        <Dropdown.Item eventKey="2">
          <button
            onClick={() => {deleteElement(elt_collection, id)}}
          >
            <MdDeleteOutline /> Remove
          </button>
        </Dropdown.Item>
        <Dropdown.Item eventKey="3">
          {isArchived === false ? (
            <button
              onClick={() => {
                updateOnTrue(elt_collection, id, myArchice, trueArchive);
              }}
            >
              <IoMdArchive /> Archive
            </button>
          ) : (
            <button
              onClick={() => {
                updateOnFalse(elt_collection, id, myArchice, falseArchive);
              }}
            >
              <MdUnarchive /> Desarchive
            </button>
          )}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="text-uppercase">
                Modifier user
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Form onSubmit={handleSubmit(onUpdate)}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control
                    defaultValue={userDatas.nom}
                    {...register("nom", {
                      required: true,
                      maxLength: 15,
                      pattern: /^[A-Za-z]+$/i
                    })}
                    type="text"
                    placeholder="Nom"
                  />
                  {errors?.nom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                  {errors?.nom?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 15 lettres</p>
                  )}
                  {errors?.nom?.type === "pattern" && (
                    <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Nom</Form.Label>
                  <Form.Control
                    defaultValue={userDatas.prenom}
                    {...register("prenom", {
                      require: true,
                      maxLength: 25,
                      pattern: /^[A-Za-z]+$/i
                    })}
                    type="text"
                    placeholder="Prénom"
                  />
                  {errors?.prenom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                  {errors?.prenom?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 25 lettres</p>
                  )}
                  {errors?.prenom?.type === "pattern" && (
                    <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Téléphone</Form.Label>
                    <Form.Control
                      defaultValue={userDatas.tel}
                      {...register("tel", {
                        require: true,
                        maxLength: 9,
                        pattern: /^7[0,5,6,7,8]\d+$/
                      })}
                      type="tel"
                      placeholder="Numéro de télephone"
                    />
                    {errors?.tel?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                    {errors?.tel?.type === "maxLength" && (
                      <p className="text-danger">un numéro de téléphone comporte 9 chiffres</p>
                    )}
                    {errors?.tel?.type === "pattern" && (
                      <p className="text-danger">Il ne prend que des chiffres commençant par 70, 75, 76, 77 ou 78 </p>
                    )}
                  </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Résidence</Form.Label>
                  <Form.Control
                    defaultValue={userDatas.residence}
                    {...register("residence", { require: true, maxLength: 20 })}
                    type="text"
                    placeholder="Residence"
                  />
                  {errors?.residence?.type === "maxLength" && (
                    <p className="text-danger">La longueur maximal est de 20 lettres</p>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Domaine</Form.Label>
                  <Form.Select
                    {...register("domaine")}
                    defaultValue={userDatas.domaine}
                  >
                    <option value="Programmation">Programmation</option>
                    <option value="Design">Design</option>
                    <option value="Marketing Digital">Marketing Digital</option>
                    <option value="Gestion de projet">Gestion de projet</option>
                  </Form.Select>
                </Form.Group>

                <Form.Control type="submit" value="Mettre à jour" className="bg-success text-white fw-bold"/>
              </Form>
            </Offcanvas.Body>
          </Offcanvas>
    </>
  );
};

export default Crud;
